import { List } from "immutable";
import { createAction } from "redux-actions";
import * as NotiActions from "./NotificationActions";
import * as M from "../models";
import { Thunk } from "./Thunk";
import { Api } from "../services/Api";

const prefix = "ADMIN_PAGE_LIST_";

export class Constants {
    public static RECEIVED_ALL = prefix + "RECEIVED_ALL";
    public static UPDATED_LIST = prefix + "UPDATED_LIST";
}

export interface AllDataReceivedPayload {
    navItems: M.AdminPage.ListItem[];
}

export type UpdateNavItemsPayload = List<M.AdminPage.ListItem>;

export const loadData = (): Thunk => async (dispatch, getState) => {
    const api = new Api(getState());
    const pagesResult = await api.get<M.AdminPage.ListItem[]>(Api.endpoints.admin.page.list);

    if (pagesResult.isSuccess && pagesResult.data) {
        dispatch(onAllReceived(pagesResult.data));
    }
    else {
        dispatch(NotiActions.notifyError(pagesResult.errors.join("<br />")));
        dispatch(onAllReceived([]));
    }
};

export const updatePages = createAction<UpdateNavItemsPayload, List<M.AdminPage.ListItem>>(
    Constants.UPDATED_LIST, (navItems) => (navItems),
);

export const onAllReceived = createAction<AllDataReceivedPayload, M.AdminPage.ListItem[]>(
    Constants.RECEIVED_ALL, (navItems) => ({ navItems }),
);



// WEBPACK FOOTER //
// ./src/actions/AdminPageListActions.ts